import { FileSelection } from "../PlatformActions";

const files: FileSelection[] = [
    {
        includedFilePaths: [
            "file1.txt",
            "file2.json",
            "File with intentionally very slightly longer name.txt",
            "I have a very very very long file name just so that I can waste readers time.txt",
            "I_have_a_very_very_very_long_file_name_just_so_that_I_can_waste_readers_time.txt",
        ],
        deniedFilePaths: [
            "file3.dll"
        ]
    },
    {
        includedFilePaths: [
            "file4.txt",
            "file5.jpg",
        ],
        deniedFilePaths: []
    },
];

export default files;
